import { NotificationsList } from "@circle-react-shared/Notifications/List";
import type { Tab } from "@circle-react-shared/Notifications/NotificationContext";
import type { NotificationTab } from "@circle-react-shared/Notifications/types";
import { Tabs } from "@circleco/compass/components/Tabs";

interface NotificationTabsV4Props {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
  tabs: NotificationTab[];
  tabsContainerRef: (node: HTMLDivElement | null) => void;
  tabsContainerWidth: number;
}

export const NotificationTabsV4 = ({
  activeTab,
  onTabChange,
  tabs,
  tabsContainerRef,
  tabsContainerWidth,
}: NotificationTabsV4Props) => {
  const handleChange = (value: string) => {
    const matched = tabs.find(tab => tab.value === value);
    if (matched) onTabChange(matched.value);
  };

  return (
    <div className="text-dark flex min-h-0 w-fit flex-1 flex-col overflow-hidden">
      <div ref={tabsContainerRef} className="w-fit shrink-0">
        <Tabs.Root
          tabs={tabs}
          selectedValue={activeTab}
          onValueChange={handleChange}
          data-testid="notifications-tabs"
          size="md"
          className="mx-6"
        />
      </div>
      <div className="border-primary mt-4 w-full shrink-0 border-b" />
      <NotificationsList style={{ width: tabsContainerWidth }} />
    </div>
  );
};
